import * as React from 'react';
import {
	ComboboxMultipleSelection,
	Options,
} from '@/components/ui/comboboxMultipleSelection';
import { useFilters } from '@/hooks';
import useDeviceWidth from '@/hooks/useDeviceWidth';
import { useQuery } from '@tanstack/react-query';
import { GET_CASE_CLIENTS_DOCUMENTS, lawyerDirectoryService } from '@/api';
import { useRouter } from 'next/router';

export const DocFilter = () => {
	const FILTER_KEY = 'documents';
	const router = useRouter();
	const { id: caseId } = router.query;
	const width = useDeviceWidth();
	const { setParamFilter, query, hasFilter } = useFilters();
	const [selected, setSelected] = React.useState<string[]>([]);
	const [isOpen, setIsOpen] = React.useState(false);
	const [optionsDefined, setOptionsDefined] = React.useState<Options[]>([]);

	const { data: stepperData } = useQuery({
		queryKey: [GET_CASE_CLIENTS_DOCUMENTS, caseId],
		queryFn: () => lawyerDirectoryService.getDocumentsList(caseId as string),
		enabled: !!caseId,
	});

	React.useEffect(() => {
		if (stepperData) {
			const auxOptions: Options[] = [];
			stepperData.data.map((item) =>
				auxOptions.push({
					label: item.name,
					value: item.name,
				})
			);
			setOptionsDefined(auxOptions);
		}
	}, [stepperData]);

	const handleSelectFilters = (value?: string): void => {
		if (value) {
			const newSelected = selected.includes(value)
				? selected.filter((s) => s !== value)
				: [...selected, value];
			setParamFilter(FILTER_KEY, newSelected.join(','));
		}
	};

	const handleClearAll = (): void => {
		setParamFilter(FILTER_KEY, '');
		setSelected([]);
	};

	React.useEffect(() => {
		const queryParam = query[FILTER_KEY] as string;
		if (queryParam) {
			const value = queryParam.split(',');
			setSelected(value);
		} else {
			setSelected([]);
		}
	}, [query]);

	return (
		<ComboboxMultipleSelection
			open={isOpen}
			setOpen={(value) => {
				if (width > 640) setIsOpen(value);
			}}
			hasFilter={hasFilter(FILTER_KEY)}
			buttonContentDefault={true}
			values={selected}
			labelDropdown="Doc"
			filterOptions={optionsDefined}
			handleSelectFilters={handleSelectFilters}
			handleClearAll={handleClearAll}
			classNamePopoverContent="!w-[420px]"
			classNameTrigger="h-[33px] !px-2 !w-[73px]"
		/>
	);
};
